import { useSidebarOpenState } from '@backstage/core-components';

// A text section heading inside the expanded drawer (e.g. "Company"). Backstage's
// SidebarGroup label only surfaces in the mobile overlay, not the desktop drawer,
// so the grouping headings in PortalSidebar.dc.html are rendered here. Hidden when
// the sidebar is collapsed, where only icons show. Styled in hone-portal.css.
export function SidebarSectionLabel({ label }: { label: string }) {
  const { isOpen } = useSidebarOpenState();

  if (!isOpen) {
    return null;
  }

  return <div className="hone-sidebar-section-label">{label}</div>;
}
